import Subscription from 'views/subscription/Subscription.container';

export default Subscription;
